"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3879],{

/***/ 3879:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ connected_products_grid_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./constants/work-managment-logos.js
var work_managment_logos = __webpack_require__(74329);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
// EXTERNAL MODULE: ./segments/desktop/constants.js
var constants = __webpack_require__(73759);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/connected-products-grid/connected-products-grid-component.scss.js




var StyledConnectedProductsGridComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e124km9c0"
})("max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, 'px;margin:auto;.products-wrapper{display:flex;background-image:url("https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/work%20management_new%20product%20page/products/background_grid.png");.work-management-icon{display:flex;flex-direction:column;justify-content:center;margin-right:25px;margin-left:150px;}.plus-icon{display:flex;flex-direction:column;justify-content:center;}.products{height:100%;display:flex;flex-wrap:wrap;margin-left:50px;.grid-image-with-paragraph-component-wrapper{justify-content:center;width:300px;margin:16px;.card-grid-link{.grid-image-with-paragraph{padding:26px;border-radius:4px;box-shadow:unset;', (0,constants.getComponentShadow)(), "            &:hover{transform:scale(1.05);", (0,constants.getComponentShadowWithHoverEffect)(), "}.paragraph-body-wrapper{.paragraph-wrapper .paragraph-body{font-size:0.875rem;line-height:24px;}}.grid-image-wrapper{.grid-image{justify-content:center;}}.grid-paragraph-wrapper{.title-wrapper{height:unset;margin-bottom:unset;.core-title-container .core-title{display:none;}}.paragraph-body-wrapper{text-align:center;}}}}}}}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){.products-wrapper{align-items:center;flex-direction:column;background-image:unset;.work-management-icon{margin-left:unset;margin-right:unset;align-self:center;.picture-component{img{width:116px;}}}.plus-icon{align-self:center;padding-top:20px;padding-bottom:20px;.picture-component{img{width:24px;}}}.products{max-width:360px;margin-left:0px;justify-content:center;.grid-image-with-paragraph-component-wrapper{width:unset;margin:8px;.card-grid-link{.grid-image-with-paragraph{padding:24px;&:hover{", (0,constants.getComponentShadow)(), "                transform:unset;}.grid-image-wrapper{.grid-image{.picture-component{display:flex;width:80px;}}}}.grid-paragraph-wrapper{display:none;}}}}}}");

// EXTERNAL MODULE: ./segments/desktop/core-components/grid-image-with-paragraph/grid-image-with-paragraph.js + 2 modules
var grid_image_with_paragraph = __webpack_require__(47755);
// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/connected-products-grid/default-props.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


var getGridImageWithParagraphProps = function(imageSrc, fullParagraphTitle, fullParagraphBody) {
    var fullParagraph = _object_spread_props(_object_spread({}, grid_image_with_paragraph/* default.defaultProps.fullParagraph */.Z.defaultProps.fullParagraph), {
        title: fullParagraphTitle,
        body: fullParagraphBody
    });
    return _object_spread_props(_object_spread({}, grid_image_with_paragraph/* default.defaultProps */.Z.defaultProps), {
        src: imageSrc,
        fullParagraph: fullParagraph
    });
};
/* harmony default export */ var default_props = ({
    gridItems: [
        getGridImageWithParagraphProps("https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/work%20management_new%20product%20page/products/marketer_product_logo.png", "marketing", "Strategize, execute, and manage campaigns from idea to launch."),
        getGridImageWithParagraphProps("https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/work%20management_new%20product%20page/products/crm_product_logo.png", "crm", "Gain visibility into your sales pipeline to boost productivity."),
        getGridImageWithParagraphProps("https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/work%20management_new%20product%20page/products/dev_product_logo.png", "dev", "Plan, execute, and collaborate to deliver better products faster."),
        getGridImageWithParagraphProps("https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/work%20management_new%20product%20page/products/projects_product_logo.png", "projects", "Streamline portfolios to finish on time and on budget.")
    ],
    paddingTop: "64px",
    paddingBottom: "64px",
    titleSize: sizes.XS,
    textSize: sizes.MD
});

// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/connected-products-grid/connected-products-grid-component.js
function connected_products_grid_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function connected_products_grid_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            connected_products_grid_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function connected_products_grid_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function connected_products_grid_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        connected_products_grid_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}






var IMAGE_HEIGHT = "100%";
var IMAGE_WIDTH = "100%";
var WORK_MANAGEMENT_LOGO = work_managment_logos/* default.WM_PRODUCT_LOGO */.Z.WM_PRODUCT_LOGO;
var PLUS_ICON_LINK = "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/work%20management_new%20product%20page/products/plus_icon.png";
var ConnectedProductsGridComponent = function(props) {
    var renderGridItems = function() {
        var gridItems = props.gridItems, textSize = props.textSize;
        return gridItems === null || gridItems === void 0 ? void 0 : gridItems.map(function(gridItem, index) {
            var fullParagraph = gridItem.fullParagraph, restImageProps = _object_without_properties(gridItem, [
                "fullParagraph"
            ]);
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid-image-with-paragraph-component-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(grid_image_with_paragraph/* default */.Z, connected_products_grid_component_object_spread_props(connected_products_grid_component_object_spread({}, restImageProps), {
                    fullParagraph: fullParagraph,
                    width: IMAGE_WIDTH,
                    height: IMAGE_HEIGHT,
                    textSize: textSize,
                    hideButton: true
                }))
            }, index);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledConnectedProductsGridComponent, {
        className: "connected-products-grid-component",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "products-wrapper",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "work-management-icon",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                        src: WORK_MANAGEMENT_LOGO,
                        alt: "monday work management"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "plus-icon",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                        src: PLUS_ICON_LINK
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "products",
                    children: renderGridItems()
                })
            ]
        })
    });
};
ConnectedProductsGridComponent.defaultProps = default_props;
/* harmony default export */ var connected_products_grid_component = (ConnectedProductsGridComponent);


/***/ })

}]);